/* Landing: apariciones suaves, clips y carruseles. Sin librerías; se carga una sola vez (defer) desde layout/theme.liquid.
   1. Este script, y solo él, pone lp-reveal-on en <html>, y solo con IntersectionObserver y sin «reducir movimiento» (en el editor de
      temas se muestra todo sin animar). Antes marca con is-in lo que ya está en pantalla o por encima. Sin JS, todo se ve desde el principio.
   2. video[data-lp-clip]: se reproduce solo mientras está a la vista (umbral 0,5); con movimiento reducido no arranca. Los de la ficha (caja
      [data-lp-vid], snippet lp-vid) llevan además un botón de reproducir oculto: se enseña con movimiento reducido, sin IntersectionObserver o si el
      navegador rechaza el arranque (play() falla), y se oculta al reproducirse; el clic lo reproduce. Los clips de la portada no llevan botón.
      Con sound: true (lp-vid) llevan también un botón de sonido [data-lp-vid-sound] (nace oculto; este script lo enseña): el vídeo siempre arranca en
      silencio, el clic alterna video.muted (y, si estaba parado, lo reproduce) y al salir de la vista se pausa y se vuelve a silenciar.
   3. [data-lp-uses-track], [data-lp-story-track] y [data-lp-videos-track]: sin tabindex cuando no se desplazan (ordenador) y con él cuando sí.
   4. [data-lp-announce]: barra de anuncios con varios mensajes, uno cada vez (cada 4,5 s). Solo cambia clases (is-active / is-before): el CSS hace el relevo y la
      barra tiene alto fijo. No rota con un solo mensaje, con «reducir movimiento» ni sin JavaScript (queda el primero). En pausa con la pestaña oculta, con el
      puntero encima y con el foco dentro; un enlace enfocado muestra su mensaje.
   1a. Qué aparece (28-10-2026): solo el CONTENIDO de cada sección (titulares, textos, tarjetas, imágenes). El nodo que lleva el fondo (color-*, gradient) y las ondas (lp-onda) no
      llevan nunca data-lp-reveal: los cambios de color entre secciones están fijos al hacer scroll. Las secciones que marcan sus propios hijos se respetan; las demás, tag() baja por
      las capas con fondo y marca sus hijos de contenido (no los adornos: svg, aria-hidden, absolute/fixed). Sin aparición: hero escaparate (.lp-esc) y hero foto (.lp-fh), cinta (.lp-ribbon), bloque fijo y caja de compra.
   1b. Ficha de producto (28-10-2026): con .ficha-product en la página, además lp-reveal-ficha en <html> (apariciones de 12 px y 0,38 s, escalón de 50 ms) y las preguntas
      frecuentes aparecen una a una. La caja de compra (main-product) sigue sin data-lp-reveal: su primera pantalla se pinta al momento.
   5. [data-lp-cookie-prefs] (pie): oculto hasta que hay window.lpCookies (aviso propio, lp-cookies.js) o window.privacyBanner (nativo); se mira al
      cargar y cada 0,5 s, 15 s. El clic abre el panel del que exista (el propio, si están los dos). Sin ninguno, sigue oculto.
   6. a[data-lp-ancla="id"] (03-11-2026; botón secundario del hero, ajuste esc_button2_anchor): si en la página hay un elemento con ese id, el clic baja hasta él con desplazamiento
      suave (instantáneo con «reducir movimiento») y deja el foco en su titular (h2[tabindex]) sin mover la página. Sin JavaScript o sin el elemento, el enlace va a su href.
      El borde de arriba queda bajo la cabecera fija por el scroll-margin-top del destino. Clic con Ctrl, Cmd, Mayús o botón medio: lo trata el navegador (otra pestaña). */
(() => {
  if (window.__lpMotion) return;
  window.__lpMotion = true;

  const doc = document.documentElement;
  const hasIO = 'IntersectionObserver' in window;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const design = !!(window.Shopify && window.Shopify.designMode);
  const seen = new WeakSet();
  let clipIO = null;

  // Apariciones en toda la web (26-10-2026; rehechas el 28-10-2026): las listas de tarjetas (beneficios, ficha técnica, pasos) aparecen tarjeta a tarjeta, con 70 ms de
  // escalón (--lp-i). Toda sección de #MainContent sin apariciones propias (ni bloque fijo ni caja de compra ni cinta) hace aparecer SU CONTENIDO, nunca su envoltorio ni su
  // fondo: los colores de cada sección y las ondas (lp-onda) están siempre en su sitio, sin fundido ni desplazamiento. Lo ya visible al cargar no se anima (is-in de abajo).
  const CARRIER = /(^|\s)(gradient|color-[\w-]+)(\s|$)/;
  // Adorno o capa suelta: scripts, SVG (ondas), nodos aria-hidden (brasas, escenas), ocultos o fuera de flujo (absolute/fixed)
  const isDecor = (n) => {
    if (n.nodeType !== 1 || n.matches('script,style,link,template,noscript,svg,.lp-onda,[aria-hidden="true"],[hidden]')) return true;
    const pos = getComputedStyle(n).position;
    return pos === 'absolute' || pos === 'fixed';
  };
  // Nodo que lleva el fondo de la sección (esquema de color, degradado, color o imagen de fondo)
  const isLayer = (n) => {
    if (CARRIER.test(n.getAttribute('class') || '')) return true;
    const cs = getComputedStyle(n);
    return cs.backgroundImage !== 'none' || (cs.backgroundColor !== 'rgba(0, 0, 0, 0)' && cs.backgroundColor !== 'transparent');
  };
  // Baja por las capas con fondo hasta el contenido (máximo 3 niveles) y marca solo los hijos de contenido
  const tagContent = (node, depth) => {
    [...node.children].forEach((c) => {
      if (isDecor(c)) return;
      if (!isLayer(c)) {
        c.setAttribute('data-lp-reveal', '');
        return;
      }
      if (depth < 3 && [...c.children].some((k) => !isDecor(k))) tagContent(c, depth + 1);
    });
  };
  const tag = () => {
    document.querySelectorAll('.benefit-icons__list, .lp-specs__list, .lp-steps__list').forEach((l) => {
      l.removeAttribute('data-lp-reveal');
      [...l.children].forEach((c, i) => {
        c.setAttribute('data-lp-reveal', '');
        c.style.setProperty('--lp-i', i % 4);
      });
    });
    // Ficha de producto (28-10-2026): las preguntas frecuentes aparecen pregunta a pregunta (la portada las deja en bloque)
    if (document.querySelector('.ficha-product'))
      document.querySelectorAll('.lp-faq__list').forEach((l) => {
        l.removeAttribute('data-lp-reveal');
        [...l.children].forEach((c, i) => {
          c.setAttribute('data-lp-reveal', '');
          c.style.setProperty('--lp-i', i % 4);
        });
      });
    // Nunca el envoltorio de una sección ni una onda ni nada que contenga una (por si alguna plantilla los marcara): el fondo no se anima
    document.querySelectorAll('[data-lp-reveal]').forEach((el) => {
      if (el.matches('.shopify-section, .lp-onda, .lp-esc, .lp-fh') || el.querySelector('.lp-onda, .lp-esc, .lp-fh')) el.removeAttribute('data-lp-reveal');
    });
    document.querySelectorAll('#MainContent .shopify-section').forEach((s) => {
      if (!s.querySelector('[data-lp-reveal], .lp-pinned, [data-pack-buy-main], .lp-esc, .lp-fh, .lp-ribbon')) tagContent(s, 0);
    });
  };

  const reveal = () => {
    if (!hasIO || reduce || design || doc.classList.contains('lp-reveal-on')) return;
    tag();
    const height = window.innerHeight || doc.clientHeight;
    const later = [];
    document.querySelectorAll('[data-lp-reveal]').forEach((el) => {
      if (el.getBoundingClientRect().top < height) el.classList.add('is-in');
      else later.push(el);
    });
    doc.classList.add('lp-reveal-on');
    // En la ficha de producto las apariciones son más cortas y ligeras (ficha-producto.css, bloque «Apariciones ligeras»)
    if (document.querySelector('.ficha-product')) doc.classList.add('lp-reveal-ficha');
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          // en pantalla, o ya por encima (se llegó con un enlace): aparece y deja de observarse
          if (e.isIntersecting || e.boundingClientRect.bottom < 0) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        }),
      { rootMargin: '0px 0px -10% 0px' }
    );
    later.forEach((el) => io.observe(el));
    // Al llegar al final de la página, lo que quede dentro del 10 % inferior (que el observador no cuenta) aparece también
    const atEnd = () => {
      if (window.innerHeight + window.scrollY < doc.scrollHeight - 2) return;
      later.forEach((el) => {
        el.classList.add('is-in');
        io.unobserve(el);
      });
      window.removeEventListener('scroll', atEnd);
    };
    window.addEventListener('scroll', atEnd, { passive: true });
  };

  // Botón de reproducir de los vídeos de la ficha (caja [data-lp-vid]): oculto salvo que el vídeo no pueda arrancar solo
  const playButton = (video) => {
    const box = video.closest('[data-lp-vid]');
    return box ? box.querySelector('[data-lp-vid-play]') : null;
  };
  const showPlay = (video, on) => {
    const button = playButton(video);
    if (button) button.hidden = !on;
  };

  const clips = () => {
    const list = document.querySelectorAll('video[data-lp-clip]');
    if (!list.length) return;
    if (!hasIO || reduce) {
      list.forEach((v) => showPlay(v, true));
      return;
    }
    clipIO =
      clipIO ||
      new IntersectionObserver(
        (entries) =>
          entries.forEach((e) => {
            if (!e.isIntersecting) {
              e.target.pause();
              e.target.muted = true; // fuera de pantalla no suena; el botón se actualiza con volumechange
              return;
            }
            const p = e.target.play();
            if (p && p.then) p.then(() => showPlay(e.target, false), () => showPlay(e.target, true));
          }),
        { threshold: 0.5 }
      );
    list.forEach((v) => {
      if (!seen.has(v)) {
        seen.add(v);
        clipIO.observe(v);
      }
    });
  };

  document.addEventListener('click', (e) => {
    const button = e.target.closest && e.target.closest('[data-lp-vid-play]');
    if (!button) return;
    const video = button.closest('[data-lp-vid]').querySelector('video');
    if (!video) return;
    button.hidden = true;
    const p = video.play();
    if (p && p.catch) p.catch(() => (button.hidden = false));
  });

  // Botón de sonido (solo en los lp-vid con sound: true): refleja video.muted en aria-pressed (true = suena) y en la etiqueta
  const syncSound = (video) => {
    const box = video.closest('[data-lp-vid]');
    const button = box && box.querySelector('[data-lp-vid-sound]');
    if (!button) return;
    button.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
    button.setAttribute('aria-label', video.muted ? 'Activar sonido' : 'Silenciar');
  };
  document.addEventListener('click', (e) => {
    const button = e.target.closest && e.target.closest('[data-lp-vid-sound]');
    if (!button) return;
    const video = button.closest('[data-lp-vid]').querySelector('video');
    if (!video) return;
    video.muted = !video.muted;
    syncSound(video);
    if (video.muted || !video.paused) return;
    // parado (póster, movimiento reducido o sin autoarranque): al activar el sonido se reproduce; si el navegador lo rechaza, vuelve a silencio
    showPlay(video, false);
    const p = video.play();
    if (p && p.catch)
      p.catch(() => {
        video.muted = true;
        syncSound(video);
        showPlay(video, true);
      });
  });
  // volumechange no burbujea: se escucha en captura para cubrir también el silencio automático al salir de la vista
  document.addEventListener('volumechange', (e) => e.target && e.target.matches && e.target.matches('video[data-lp-clip]') && syncSound(e.target), true);
  const soundButtons = () => document.querySelectorAll('[data-lp-vid-sound]').forEach((b) => (b.hidden = false));

  const tracks = () =>
    document.querySelectorAll('[data-lp-uses-track], [data-lp-story-track], [data-lp-videos-track]').forEach((t) => {
      if (t.scrollWidth > t.clientWidth + 1) t.setAttribute('tabindex', '0');
      else t.removeAttribute('tabindex');
    });

  // 4. Barra de anuncios: un mensaje a la vista y relevo cada 4,5 s
  let announceStop = null;
  const announce = () => {
    const bar = document.querySelector('[data-lp-announce]');
    if (!bar || bar.hasAttribute('data-lp-announce-on')) return;
    if (announceStop) announceStop();
    const items = Array.from(bar.querySelectorAll('[data-lp-announce-item]'));
    if (items.length < 2 || reduce) return;
    bar.setAttribute('data-lp-announce-on', '');

    let current = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
    let timer = 0;
    let held = false; // puntero encima o foco dentro: en pausa

    const show = (next) => {
      if (next === current) return;
      const entering = items[next];
      // el que entra parte siempre de abajo, aunque la vez anterior saliera por arriba: se recoloca sin animar
      bar.classList.add('is-reset');
      entering.classList.remove('is-before');
      void entering.offsetWidth;
      bar.classList.remove('is-reset');
      items[current].classList.remove('is-active');
      items[current].classList.add('is-before');
      entering.classList.add('is-active');
      current = next;
    };
    const stop = () => {
      window.clearTimeout(timer);
      timer = 0;
    };
    const arm = () => {
      stop();
      if (document.hidden || held) return;
      timer = window.setTimeout(() => {
        show((current + 1) % items.length);
        arm();
      }, 4500);
    };
    const hold = (value) => {
      held = value;
      arm();
    };

    bar.addEventListener('pointerenter', (e) => e.pointerType === 'mouse' && hold(true));
    bar.addEventListener('pointerleave', (e) => e.pointerType === 'mouse' && hold(false));
    bar.addEventListener('focusin', (e) => {
      const i = items.findIndex((item) => item.contains(e.target));
      if (i >= 0) show(i);
      hold(true);
    });
    bar.addEventListener('focusout', () => hold(false));
    document.addEventListener('visibilitychange', arm);
    announceStop = () => {
      stop();
      document.removeEventListener('visibilitychange', arm);
    };
    arm();
  };

  const cookiePrefs = () => {
    const items = [...document.querySelectorAll('[data-lp-cookie-prefs]:not([data-lp-armed])')];
    if (!items.length) return;
    const own = () => window.lpCookies && typeof window.lpCookies.open === 'function';
    const api = () => window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
    items.forEach((li) => {
      li.setAttribute('data-lp-armed', '');
      li.querySelector('button').addEventListener('click', (e) => {
        if (own()) window.lpCookies.open(e.currentTarget);
        else if (api()) Promise.resolve(window.privacyBanner.showPreferences()).catch(() => {});
      });
    });
    let tries = 0;
    const look = () => {
      if (own() || api()) items.forEach((li) => (li.hidden = false));
      else if (++tries < 30) window.setTimeout(look, 500);
    };
    if (document.readyState === 'complete') look();
    else window.addEventListener('load', look, { once: true });
  };


  // 6. «La calle habla» (carrusel de tarjetas de Judge.me en una sección apps, .lp-apps): pasa solo a la siguiente opinión cada 4 s. El bloque no trae ajuste de autoplay
  //    (sus ajustes: transition_speed, arrows_position…), así que se pulsa su botón «siguiente» (al llegar al final, el «anterior» hasta el principio). Pausa con el puntero encima,
  //    el dedo puesto o el foco dentro, y se reanuda 4 s después de soltar; solo corre con el carrusel a la vista. Defensivo: sin carrusel o sin botón, no hace nada;
  //    con «reducir movimiento», no arranca. El carrusel lo pinta la app tarde: se busca hasta 20 s.
  const reviewsAuto = () => {
    if (reduce || !hasIO || design || window.__lpReviewsAuto) return;
    const sel = {
      next: '[class*="next-btn"], [class*="btn--next"], [class*="arrow-next"], [class*="arrow--next"], button[aria-label="Next"], button[aria-label="next"], button[aria-label="Siguiente"]',
      prev: '[class*="prev-btn"], [class*="btn--prev"], [class*="arrow-prev"], [class*="arrow--prev"], button[aria-label="Previous"], button[aria-label="previous"], button[aria-label="Anterior"]',
    };
    const off = (b) => !b || b.disabled || b.getAttribute('aria-disabled') === 'true' || /disabled|inactive|hidden/.test(b.className);
    let tries = 0;
    const find = () => {
      const box = document.querySelector('.lp-apps');
      const next = box && box.querySelector(sel.next);
      if (!next) {
        // Montaje al acercarse (sections/apps.liquid, «lazy_mount»): mientras el bloque siga en su <template> no se gastan intentos; se espera a que se monte.
        if (!(box && box.querySelector('[data-lp-lazy-mount]:not([data-lp-mounted])'))) tries++;
        return tries < 40 && window.setTimeout(find, 500);
      }
      window.__lpReviewsAuto = true;
      let held = false;
      let seen = false;
      let timer = 0;
      const step = () => {
        timer = 0;
        if (!held && seen && !document.hidden) {
          if (off(next)) {
            const prev = box.querySelector(sel.prev);
            for (let i = 0; i < 30 && prev && !off(prev); i++) prev.click();
          } else next.click();
        }
        arm();
      };
      const arm = () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(step, 4000);
      };
      const hold = (v) => {
        held = v;
        arm();
      };
      box.addEventListener('pointerenter', (e) => e.pointerType === 'mouse' && hold(true));
      box.addEventListener('pointerleave', (e) => e.pointerType === 'mouse' && hold(false));
      box.addEventListener('touchstart', () => hold(true), { passive: true });
      box.addEventListener('touchend', () => hold(false), { passive: true });
      box.addEventListener('touchcancel', () => hold(false), { passive: true });
      box.addEventListener('focusin', () => hold(true));
      box.addEventListener('focusout', () => hold(false));
      new IntersectionObserver((es) => es.forEach((e) => (seen = e.isIntersecting)), { threshold: 0.3 }).observe(box);
      arm();
    };
    find();
  };

  // 6. Botón que baja hasta una sección de la misma página (delegado: sirve también para secciones recargadas en el editor)
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.addEventListener('click', (e) => {
    const link = e.target.closest && e.target.closest('a[data-lp-ancla]');
    if (!link || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const dest = document.getElementById(link.dataset.lpAncla);
    if (!dest) return;
    e.preventDefault();
    dest.scrollIntoView({ block: 'start', behavior: calm.matches ? 'instant' : 'smooth' });
    // Foco en el titular del destino (lector de pantalla y teclado siguen desde ahí) sin mover la página
    const head = dest.querySelector('h1, h2, h3');
    if (head) {
      if (!head.hasAttribute('tabindex')) head.setAttribute('tabindex', '-1');
      head.focus({ preventScroll: true });
    }
  });

  const init = () => {
    reveal();
    reviewsAuto();
    clips();
    soundButtons();
    tracks();
    announce();
    cookiePrefs();
  };
  init();
  window.addEventListener('resize', tracks, { passive: true });
  document.addEventListener('shopify:section:load', init);
})();
